import { Box , List, ListItem, ListItemText, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { Cancel, Inquery1, Inquery2, Inquery3, Inquery4 } from "../../../assets";
import { CustomModal, Layout } from "../../components";
import { Button } from "../../components/button";
import FaqCard from "../../components/faq_card";
import { InsuranceRateController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";

class InsuranceRate extends InsuranceRateController {
  componentDidMount() {
    window.scrollTo(0, 0);

    const hasSeenModal = sessionStorage.getItem("hasSeenModal");

    if (!hasSeenModal) {
      this.setState({ showModal: true });
      sessionStorage.setItem("hasSeenModal", "true");
    }

  }

  render() {
    const { active } = this.state;

    return (
      <Layout title="استعلام حق‌بیمه و ثبت پیشنهاد ">
        <Helmet>
          <title>استعلام حق‌بیمه و ثبت پیشنهاد  | بیمه زندگی هامرز</title>
        </Helmet>

        <div className="insurance-rate scrollbar">
          <p className="insurance-rate-description">
            خواهشمند است جهت استعلام و خرید بیمه  ، یکی از بیمه نامه های زیر را انتخاب و به مرحله بعد بروید.
          </p>

          <div className="insurance-rate-cards">
            <FaqCard
              active={active === 1}
              myStyle={active === 1 ? "" : "deactive"}
              title="زندگی و سرمایه گذاری"
              image={Inquery1}
              onClick={() => this.setState({ active: 1 })}
            />
            <FaqCard
              active={active === 2}
              myStyle={active === 2 ? "" : "deactive"}
              title="زندگی متصل به"
              subTitle="صندوق های بازار سرمایه"
              image={Inquery2}
              onClick={() => this.setState({ active: 2 })}
            />
            <FaqCard
              active={active === 3}
              myStyle={active === 3 ? "" : "deactive"}
              title="زندگی و مسکن"
              subTitle="(مسکن متری)"
              image={Inquery3}
              onClick={() => this.setState({ active: 3 })}
            />
            <FaqCard
              myStyle="disable"
              title="مستمری متصل به معدن"
              image={Inquery4}
              onClick={() => { }}
            />
          </div>

          <Button
            myStyle="bg-light-blue table-btn"
            title="مرحله بعد"
            onClick={() => {
              const routes = ["/inquery", "/unitlink", "/projects"];
              window.location.href = routes[active - 1] || "/projects";
            }}
          />
        </div>


        <CustomModal myStyle="" openModal={this.state.showModal} onClose={() => this.setState({ showModal: !this.state.showModal })}>


          <>
            <div className=" hide-desktop">
              {/* <h1 className="title">
      فیلتر های کارمزد ها
    </h1> */}
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() => this.setState({ showModal: !this.state.showModal })} />
            </div>
            <div className="">
              {/* <div>
      <span className="text ml-50 hide-mobile bold">
        فیلتر های اعلام شده :
      </span>{" "}
    </div> */}
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() => this.setState({ showModal: !this.state.showModal })} />
            </div>
            <Typography marginBottom={"20px"} color="#00AA5B" variant="h6" component="h2" gutterBottom align="center" fontWeight="bold">
              جشنواره فروش بیمه زندگی هامرز
            </Typography>

            < >


              <Typography sx={{ textAlign: "center" }} variant="body1" marginTop={"20px"} marginBottom={"10px"} align="center">
              شرکت بیمه زندگی هامرز به مناسبت فرار رسیدن سال 1404 ضمن تبریک و آرزوی خوش برای شما و آن مجموعه محترم به منظور ایجاد انگیزه جهت معرفی و فروش خدمات بیمه زندگی هامرز اقدام به برگزاری جشنواره متناسب با حجم فروش طی مدت مقرر می نماید:              </Typography>

              <Typography variant="h6" component="h3" color="#155a9e" marginTop={"22px"} marginBottom={"5px"} fontWeight="bold">
              شرایط جشنواره :               </Typography>
              <List dense>
                <ListItem>
                  <ListItemText sx={{ textAlign: "justify" , fontWeight:"bold"}}  primary="-	مدت زمان جشنواره جهت محاسبه پرتفوی کارگزار محترم به مدت 6 ماه از تاریخ 1403/12/15 الی 1404/06/15 است." />
                </ListItem>
                <ListItem>
                  <ListItemText sx={{ textAlign: "justify" , fontWeight:"bold"}}  primary="  -	این جشنواره جهت فروش بیمه های زندگی و سرمایه گذاری و  زندگی متصل به صندوق‌های بازار سرمایه طراحی شده است. " />
                </ListItem>



                <ListItem>
                  <ListItemText sx={{ textAlign: "justify" , fontWeight:"bold"}}  primary="-	در صورت اتمام مدت زمان جشنواره برای حجم پرتفوی باقیمانده کمتر از یک میلیارد تومان پاداشی محاسبه نمی-گردد و مبنای محاسبه طبقه پاداش، میزان مانده پرتفوی در انتهای دوره جشنواره می باشد." />
                </ListItem>
                <ListItem>
                  <ListItemText sx={{ textAlign: "justify" , fontWeight:"bold"}}  primary="-	معیار محاسبه مبلغ پاداش بر اساس بازه های اعلام شده است، به عنوان مثال در صورت فروش 4 میلیارد تومان، 2 میلیارد تومان با ضریب 1.5 درصد و یک میلیارد تومان با ضریب دو درصد محاسبه می گردد. " />
                </ListItem>
                <ListItem>
                  <ListItemText sx={{ textAlign: "justify" , fontWeight:"bold"}}  primary="-	در صورت بازخرید بیمه نامه بعد از اتمام مدت جشنواره و تا پایان سال اول بیمه نامه، مبلغ بازخریدی از مانده پرتفوی کسر و پاداش مجدد محاسبه و از درآمدهای آتی کارگزار کسر خواهد گردید." />
                </ListItem>
              </List>

              <Box sx={{ overflowX: "auto", mt: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#FAFCFE" }}>
                      <TableCell align="center" sx={{ fontWeight: "bold" , color:"#155a9e" }} >درصد از حجم فروش</TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" , color:"#155a9e"}} >میزان حجم فروش </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody  >
                    {[
                      { range: "۱ الی ۳", percent: "۱ درصد " },
                      { range: "۳ الی ۵", percent: "۲ درصد " },
                      { range: "۵ الی ۷", percent: "۳ درصد " },
                      { range: "۷ الی ۱۰", percent: "۴ درصد " },
                      { range: "بیش از ۱۰", percent: "۵ درصد " },
                    ].map((row, index) => (
                      <TableRow sx={{ borderColor: "#155a9e" }} key={index}>
                        <TableCell align="center">{row.percent}</TableCell>
                        <TableCell align="center">{row.range}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </>



          </>
        </CustomModal>
      </Layout>
    );
  }
}

const mapStateToProps = (dispatch: any) => ({
  dispatch,
  userData: dispatch.general.userData,
});

export default connect(mapStateToProps)(InsuranceRate);